// src/enums.ts
var AccountType = /* @__PURE__ */ ((AccountType2) => {
  AccountType2["BANK"] = "bank";
  AccountType2["SAVINGS"] = "savings";
  AccountType2["CETES"] = "cetes";
  AccountType2["CAJA_AHORRO"] = "caja_ahorro";
  AccountType2["CASH"] = "cash";
  return AccountType2;
})(AccountType || {});
var AccountReconciliationReason = /* @__PURE__ */ ((AccountReconciliationReason2) => {
  AccountReconciliationReason2["BANK_RECONCILIATION"] = "bank_reconciliation";
  AccountReconciliationReason2["OPENING_BALANCE"] = "opening_balance";
  AccountReconciliationReason2["STATEMENT_CLOSING_BALANCE"] = "statement_closing_balance";
  AccountReconciliationReason2["CORRECTION"] = "correction";
  AccountReconciliationReason2["OTHER"] = "other";
  return AccountReconciliationReason2;
})(AccountReconciliationReason || {});
var AccountReconciliationStatus = /* @__PURE__ */ ((AccountReconciliationStatus2) => {
  AccountReconciliationStatus2["ACTIVE"] = "active";
  AccountReconciliationStatus2["REVERSED"] = "reversed";
  return AccountReconciliationStatus2;
})(AccountReconciliationStatus || {});
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["INCOME"] = "income";
  TransactionType2["EXPENSE"] = "expense";
  return TransactionType2;
})(TransactionType || {});
var CategoryKind = /* @__PURE__ */ ((CategoryKind2) => {
  CategoryKind2["INCOME"] = "income";
  CategoryKind2["EXPENSE"] = "expense";
  return CategoryKind2;
})(CategoryKind || {});
var LoanKind = /* @__PURE__ */ ((LoanKind2) => {
  LoanKind2["LOAN"] = "loan";
  LoanKind2["DEBT"] = "debt";
  return LoanKind2;
})(LoanKind || {});
var LoanPaymentStatus = /* @__PURE__ */ ((LoanPaymentStatus2) => {
  LoanPaymentStatus2["REGISTERED"] = "registered";
  LoanPaymentStatus2["UNDONE"] = "undone";
  return LoanPaymentStatus2;
})(LoanPaymentStatus || {});
var RecurringSourceKind = /* @__PURE__ */ ((RecurringSourceKind2) => {
  RecurringSourceKind2["ACCOUNT"] = "account";
  RecurringSourceKind2["CARD"] = "card";
  return RecurringSourceKind2;
})(RecurringSourceKind || {});
var RecurringDirection = /* @__PURE__ */ ((RecurringDirection2) => {
  RecurringDirection2["EXPENSE"] = "expense";
  RecurringDirection2["INCOME"] = "income";
  RecurringDirection2["TRANSFER"] = "transfer";
  return RecurringDirection2;
})(RecurringDirection || {});
var RecurringFrequency = /* @__PURE__ */ ((RecurringFrequency2) => {
  RecurringFrequency2["MONTHLY"] = "monthly";
  RecurringFrequency2["QUARTERLY"] = "quarterly";
  return RecurringFrequency2;
})(RecurringFrequency || {});
var SUPPORTED_CURRENCIES = ["MXN", "USD", "CAD"];
var APP_CURRENCY = "MXN";
var APP_TIMEZONE = "America/Mexico_City";
var PlannedMovementKind = /* @__PURE__ */ ((PlannedMovementKind2) => {
  PlannedMovementKind2["INCOME"] = "income";
  PlannedMovementKind2["EXPENSE"] = "expense";
  PlannedMovementKind2["TRANSFER"] = "transfer";
  return PlannedMovementKind2;
})(PlannedMovementKind || {});
var PlannedMovementStatus = /* @__PURE__ */ ((PlannedMovementStatus2) => {
  PlannedMovementStatus2["PLANNED"] = "planned";
  PlannedMovementStatus2["CONFIRMING"] = "confirming";
  PlannedMovementStatus2["CONFIRMED"] = "confirmed";
  PlannedMovementStatus2["CANCELLED"] = "cancelled";
  return PlannedMovementStatus2;
})(PlannedMovementStatus || {});

// src/finance/dates.ts
function calendarParts(date, timeZone = APP_TIMEZONE) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(date);
  const read = (type) => Number(parts.find((part) => part.type === type)?.value);
  return { year: read("year"), month: read("month"), day: read("day") };
}
function businessDate(value) {
  const text = typeof value === "string" ? value : void 0;
  const match = text ? /^(\d{4})-(\d{2})-(\d{2})/.exec(text) : null;
  const parts = match ? { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) } : calendarParts(typeof value === "string" ? new Date(value) : value);
  return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
}
function nextBusinessMonthDate(value) {
  const normalized = typeof value === "string" ? businessDate(value) : businessDate(value.toISOString().slice(0, 10));
  const year = normalized.getUTCFullYear();
  const nextMonth = normalized.getUTCMonth() + 1;
  const day = normalized.getUTCDate();
  const lastDay = new Date(Date.UTC(year, nextMonth + 1, 0)).getUTCDate();
  return new Date(Date.UTC(year, nextMonth, Math.min(day, lastDay), 12));
}
function businessMonthBounds(month) {
  const [year, monthNumber] = month.split("-").map((value) => Number(value));
  if (!Number.isInteger(year) || !Number.isInteger(monthNumber) || monthNumber < 1 || monthNumber > 12) {
    throw new Error(`Mes inv\xE1lido: ${month}`);
  }
  return {
    start: new Date(Date.UTC(year, monthNumber - 1, 1)),
    end: new Date(Date.UTC(year, monthNumber, 1))
  };
}
function monthToIndex(month) {
  const [y, m] = month.split("-").map((v) => parseInt(v, 10));
  if (!Number.isInteger(y) || !Number.isInteger(m) || m < 1 || m > 12) {
    throw new Error(`Mes inv\xE1lido: ${month}`);
  }
  return y * 12 + (m - 1);
}
function indexToMonth(index) {
  const y = Math.floor(index / 12);
  const m = index % 12 + 1;
  return `${y.toString().padStart(4, "0")}-${m.toString().padStart(2, "0")}`;
}
function addMonths(month, n) {
  return indexToMonth(monthToIndex(month) + n);
}
function diffMonths(a, b) {
  return monthToIndex(b) - monthToIndex(a);
}
function toYearMonth(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  const { year, month } = calendarParts(d);
  return `${year.toString().padStart(4, "0")}-${month.toString().padStart(2, "0")}`;
}
function monthsUntil(from, to) {
  const a = typeof from === "string" ? new Date(from) : from;
  const b = typeof to === "string" ? new Date(to) : to;
  const months = (b.getUTCFullYear() - a.getUTCFullYear()) * 12 + (b.getUTCMonth() - a.getUTCMonth());
  return months;
}

// src/finance/msi.ts
function assertValid(charge) {
  if (charge.msiMonths < 1) {
    throw new Error("msiMonths debe ser >= 1");
  }
  if (charge.msiPaid < 0 || charge.msiPaid > charge.msiMonths) {
    throw new Error("msiPaid debe estar entre 0 y msiMonths");
  }
}
function monthlyAmount(charge) {
  assertValid(charge);
  return charge.totalAmount / charge.msiMonths;
}
function monthsRemaining(charge) {
  assertValid(charge);
  return charge.msiMonths - charge.msiPaid;
}
function remainingBalance(charge) {
  return monthlyAmount(charge) * monthsRemaining(charge);
}
function isCash(charge) {
  return charge.msiMonths === 1;
}
function isPaidOff(charge) {
  return charge.msiPaid >= charge.msiMonths;
}
function hasPendingInstallments(charge) {
  return charge.msiPaid < charge.msiMonths;
}
function totalMsiDebt(charges) {
  return charges.reduce((sum, c) => sum + remainingBalance(c), 0);
}
function installmentProgress(charge) {
  assertValid(charge);
  return charge.msiPaid / charge.msiMonths;
}

// src/finance/cycle.ts
var MS_PER_DAY = 24 * 60 * 60 * 1e3;
function daysInMonth(year, month0) {
  return new Date(Date.UTC(year, month0 + 1, 0)).getUTCDate();
}
function clampedDate(year, month0, day) {
  const maxDay = daysInMonth(year, month0);
  return new Date(Date.UTC(year, month0, Math.min(day, maxDay)));
}
function atUtcMidnight(d) {
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
}
function diffDays(from, to) {
  return Math.round((atUtcMidnight(to).getTime() - atUtcMidnight(from).getTime()) / MS_PER_DAY);
}
function computeCardCycle(cutoffDay, paymentDay, reference = /* @__PURE__ */ new Date()) {
  if (cutoffDay < 1 || cutoffDay > 31 || paymentDay < 1 || paymentDay > 31) {
    throw new Error("cutoffDay y paymentDay deben estar entre 1 y 31");
  }
  const ref = atUtcMidnight(typeof reference === "string" ? new Date(reference) : reference);
  const y = ref.getUTCFullYear();
  const m = ref.getUTCMonth();
  let cutoff = clampedDate(y, m, cutoffDay);
  if (cutoff.getTime() < ref.getTime()) {
    cutoff = clampedDate(y, m + 1, cutoffDay);
  }
  const prevCutoff = clampedDate(cutoff.getUTCFullYear(), cutoff.getUTCMonth() - 1, cutoffDay);
  const start = new Date(prevCutoff.getTime() + MS_PER_DAY);
  let paymentDue = clampedDate(cutoff.getUTCFullYear(), cutoff.getUTCMonth(), paymentDay);
  if (paymentDue.getTime() <= cutoff.getTime()) {
    paymentDue = clampedDate(cutoff.getUTCFullYear(), cutoff.getUTCMonth() + 1, paymentDay);
  }
  return {
    start,
    cutoff,
    paymentDue,
    daysToCutoff: Math.max(0, diffDays(ref, cutoff)),
    daysToPayment: Math.max(0, diffDays(ref, paymentDue))
  };
}
function isWithinCycle(date, cycle) {
  const d = atUtcMidnight(typeof date === "string" ? new Date(date) : date).getTime();
  return d >= atUtcMidnight(cycle.start).getTime() && d <= atUtcMidnight(cycle.cutoff).getTime();
}

// src/finance/projection.ts
function isOnOrBeforeCutoff(date, cutoff) {
  const value = typeof date === "string" ? new Date(date) : date;
  const day = Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate());
  const cutoffDay = Date.UTC(
    cutoff.getUTCFullYear(),
    cutoff.getUTCMonth(),
    cutoff.getUTCDate()
  );
  return day <= cutoffDay;
}
function projectNextStatement(charges, cutoffDay, paymentDay, reference = /* @__PURE__ */ new Date()) {
  const cycle = computeCardCycle(cutoffDay, paymentDay, reference);
  let cashInCycle = 0;
  let msiInstallments = 0;
  for (const charge of charges) {
    if (isCash(charge)) {
      if (isWithinCycle(charge.purchaseDate, cycle)) {
        cashInCycle += charge.totalAmount;
      }
    } else if (hasPendingInstallments(charge) && isOnOrBeforeCutoff(charge.purchaseDate, cycle.cutoff)) {
      msiInstallments += monthlyAmount(charge);
    }
  }
  return {
    cashInCycle,
    msiInstallments,
    total: cashInCycle + msiInstallments,
    cycle
  };
}

// src/finance/budget.ts
function projectedMonthlyClosing(input) {
  return input.monthlyIncome - input.fixedCommitments - input.savingsTarget - input.variableSpent;
}
function suggestedMonthlyLimit(input) {
  const fixedCommitments = input.cardPaymentProjected + input.loanPayments + input.recurringExpenses + (input.plannedExpenses ?? 0);
  const suggestedLimit = input.monthlyIncome - fixedCommitments - input.savingsTarget;
  return {
    fixedCommitments,
    suggestedLimit,
    overcommitted: suggestedLimit < 0
  };
}
function availableFree(monthlyLimit, variableSpent) {
  return monthlyLimit - variableSpent;
}
function limitUsageRatio(monthlyLimit, variableSpent) {
  if (monthlyLimit <= 0) return variableSpent > 0 ? Infinity : 0;
  return variableSpent / monthlyLimit;
}
function budgetStatus(monthlyLimit, variableSpent, warningThreshold = 0.85) {
  const ratio = limitUsageRatio(monthlyLimit, variableSpent);
  if (ratio > 1) return "over";
  if (ratio >= warningThreshold) return "warning";
  return "ok";
}
function isFiniteNonNegativeAmount(value) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0;
}
function sumFiniteNonNegativeAmounts(values) {
  let total = 0;
  for (const value of values) {
    if (!isFiniteNonNegativeAmount(value)) return null;
    total += value;
    if (!Number.isFinite(total)) return null;
  }
  return total;
}

// src/finance/savings.ts
function savingsSuggestion(input) {
  const reference = input.reference ?? /* @__PURE__ */ new Date();
  const remaining = Math.max(0, input.targetAmount - input.saved);
  const progress = input.targetAmount > 0 ? Math.min(1, input.saved / input.targetAmount) : 1;
  if (remaining === 0) {
    return {
      remaining: 0,
      monthsRemaining: 0,
      suggestedMonthly: 0,
      progress: 1,
      feasibility: "achieved"
    };
  }
  const rawMonths = monthsUntil(reference, input.targetDate);
  const monthsRemaining2 = Math.max(1, rawMonths);
  const suggestedMonthly = remaining / monthsRemaining2;
  let feasibility = "on_track";
  let achievableDate;
  if (input.availablePerMonth !== void 0) {
    if (input.availablePerMonth <= 0) {
      feasibility = "not_feasible";
    } else if (suggestedMonthly > input.availablePerMonth) {
      feasibility = "not_feasible";
    } else if (suggestedMonthly > input.availablePerMonth * 0.9) {
      feasibility = "tight";
    }
    if (input.availablePerMonth > 0 && suggestedMonthly > input.availablePerMonth) {
      const monthsNeeded = Math.ceil(remaining / input.availablePerMonth);
      const ref = typeof reference === "string" ? new Date(reference) : reference;
      const d = new Date(
        Date.UTC(ref.getUTCFullYear(), ref.getUTCMonth() + monthsNeeded, ref.getUTCDate())
      );
      achievableDate = d.toISOString();
    }
  }
  return {
    remaining,
    monthsRemaining: monthsRemaining2,
    suggestedMonthly,
    progress,
    feasibility,
    achievableDate
  };
}

// src/finance/recurring.ts
function recurringFrequencyMonths(rec) {
  return rec.frequency === "quarterly" /* QUARTERLY */ ? 3 : 1;
}
function isWithinRecurringTerm(rec, month) {
  if (!rec.active) return false;
  const start = monthToIndex(rec.startMonth);
  const target = monthToIndex(month);
  if (target < start) return false;
  if (rec.termMonths === null) return true;
  const monthsElapsed = target - start;
  return monthsElapsed < rec.termMonths;
}
function isActiveInMonth(rec, month) {
  if (!isWithinRecurringTerm(rec, month)) return false;
  const monthsElapsed = monthToIndex(month) - monthToIndex(rec.startMonth);
  return monthsElapsed % recurringFrequencyMonths(rec) === 0;
}
function recurringOccurrenceCount(rec) {
  if (rec.termMonths === null) return null;
  return Math.ceil(rec.termMonths / recurringFrequencyMonths(rec));
}
function recurringOccurrencesRemaining(rec) {
  const total = recurringOccurrenceCount(rec);
  return total === null ? null : Math.max(0, total - rec.monthsPaid);
}
function recurringMonthsRemaining(rec) {
  if (rec.termMonths === null) return null;
  return Math.max(0, rec.termMonths - rec.monthsPaid);
}
function isFinished(rec) {
  const total = recurringOccurrenceCount(rec);
  return total !== null && rec.monthsPaid >= total;
}
function amountForMonth(rec, month) {
  const override = rec.amountByMonth?.[month];
  return typeof override === "number" ? override : rec.amount;
}
function hasAmountOverride(rec, month) {
  return typeof rec.amountByMonth?.[month] === "number";
}
function monthlySavingsTarget(income, rate, committedSavings) {
  return Math.max(Math.round(income * rate), committedSavings);
}
function totalActiveInMonth(recs, month) {
  return recs.reduce((sum, r) => isActiveInMonth(r, month) ? sum + amountForMonth(r, month) : sum, 0);
}

// src/finance/loans.ts
function termsRemaining(loan) {
  return Math.max(0, loan.termsTotal - loan.termsPaid);
}
function loanRemainingBalance(loan) {
  return loan.monthlyPayment * termsRemaining(loan);
}
function loanProgress(loan) {
  if (loan.termsTotal <= 0) return 1;
  return Math.min(1, loan.termsPaid / loan.termsTotal);
}
function isLoanActive(loan) {
  return loan.termsPaid < loan.termsTotal;
}
function totalMonthlyLoanPayments(loans) {
  return loans.reduce((sum, l) => isLoanActive(l) ? sum + l.monthlyPayment : sum, 0);
}

// src/dto/assistant.ts
var ASSISTANT_PROPOSAL_CONTRACT_VERSION = 5;
var APP_HELP_DESTINATIONS = {
  "/panorama": "Panorama",
  "/asistente": "Asistente",
  "/cuentas": "Cuentas",
  "/transacciones": "Movimientos",
  "/tarjeta": "Tarjeta",
  "/gastos-fijos": "Movimientos fijos",
  "/deudas": "Deudas",
  "/presupuesto": "Presupuesto",
  "/metas": "Metas",
  "/ajustes": "Ajustes",
  "/mas": "M\xE1s"
};

// src/dto/users.ts
var ACCOUNT_DELETION_CONFIRMATION = "ELIMINAR MI CUENTA";

// src/app-guides.ts
var APP_GUIDE_VERSION = "2026-10-02";
var APP_SECTIONS = [
  "dashboard",
  "accounts",
  "transactions",
  "creditCard",
  "recurring",
  "loans",
  "budget",
  "goals",
  "assistant",
  "settings",
  "more"
];
var APP_SECTION_GUIDES = {
  dashboard: {
    section: "dashboard",
    route: "/panorama",
    eyebrow: "Tu resumen",
    title: "Entiende tu dinero de un vistazo",
    summary: "Aqu\xED ves lo que entr\xF3, lo que sali\xF3 y cu\xE1nto podr\xEDa quedarte al terminar el mes.",
    keyIdeas: [
      "Estimado al final del mes: c\xE1lculo de lo que podr\xEDa quedarte; cambia cuando registras m\xE1s movimientos.",
      "La app s\xF3lo puede tomar en cuenta la informaci\xF3n que hayas registrado."
    ],
    steps: [
      "Revisa Efectivo si aparece o agrega tu primera cuenta, y registra su saldo.",
      "Registra tus movimientos.",
      "Vuelve aqu\xED para revisar el resultado del mes."
    ],
    assistantShortcut: {
      title: "Revisa tu mes con el asistente",
      description: "Preg\xFAntale: \u201C\xBFC\xF3mo va mi mes?\u201D. Usar\xE1 lo que ya registraste.",
      note: "Este an\xE1lisis usa una consulta.",
      action: { label: "Preguntar por mi mes", to: "/asistente" }
    },
    action: { label: "Revisar mis cuentas", to: "/cuentas" }
  },
  accounts: {
    section: "accounts",
    route: "/cuentas",
    eyebrow: "Cuentas y apartados",
    title: "\xBFD\xF3nde est\xE1 guardado tu dinero?",
    summary: "Registra tus cuentas, efectivo y otras formas de ahorro para saber cu\xE1nto tienes hoy.",
    keyIdeas: [
      "Saldo total: todo el dinero de la cuenta, incluido lo que separaste.",
      "Disponible: lo que puedes usar despu\xE9s de restar tus apartados.",
      "Apartado: dinero que separas para no gastarlo; sigue dentro de la misma cuenta.",
      "Conciliar saldo: compara la app con tu banco y te ayuda a registrar la causa real de cualquier diferencia.",
      "El asistente puede guiarte, pero la cuenta y su saldo se agregan aqu\xED."
    ],
    steps: [
      "Revisa Efectivo si aparece o agrega una cuenta y registra su saldo actual.",
      "Usa Conciliar saldo cuando la app y el banco no coincidan.",
      "Indica si falt\xF3 un movimiento o si s\xF3lo necesitas corregir el saldo.",
      "Si quieres, separa una parte en un apartado."
    ],
    action: { label: "Revisar mis cuentas", to: "/cuentas" }
  },
  transactions: {
    section: "transactions",
    route: "/transacciones",
    eyebrow: "Movimientos",
    title: "Registra lo que realmente pas\xF3",
    summary: "Registra el dinero que entr\xF3 o sali\xF3 para mantener tus saldos y tu resumen al d\xEDa.",
    keyIdeas: [
      "Ingreso: dinero que entr\xF3 a una cuenta.",
      "Gasto: dinero que sali\xF3 de una cuenta.",
      "Traspaso: dinero que moviste entre cuentas tuyas; no es un ingreso ni un gasto."
    ],
    steps: [
      "Elige qu\xE9 ocurri\xF3.",
      "Escribe el monto y la cuenta.",
      "Revisa la fecha antes de guardar."
    ],
    assistantShortcut: {
      title: "\xBFPrefieres contarlo en vez de llenar el formulario?",
      description: "Escribe: \u201CHoy gast\xE9 $480 en el s\xFAper con mi cuenta principal\u201D. El asistente reconoce la fecha, te ayuda a elegir la categor\xEDa y te muestra c\xF3mo cambia tu saldo. T\xFA revisas y confirmas.",
      note: "Interpretar el mensaje inicial usa 1 consulta. Guardar o cancelar la propuesta no usa otra. Necesitas una prueba activa o una suscripci\xF3n.",
      action: { label: "Contar este gasto", to: "/asistente" }
    },
    action: { label: "Registrar un movimiento", to: "/transacciones?accion=nuevo" }
  },
  creditCard: {
    section: "creditCard",
    route: "/tarjeta",
    eyebrow: "Tarjeta de cr\xE9dito",
    title: "Controla lo que debes y cu\xE1ndo pagarlo",
    summary: "Registra compras, pagos y compras a meses para ver tu deuda y lo que viene en los pr\xF3ximos cortes.",
    keyIdeas: [
      "Fecha de corte: d\xEDa en que tu banco cierra las compras de ese periodo.",
      "Fecha l\xEDmite de pago: \xFAltimo d\xEDa para pagar a tiempo.",
      "Meses sin intereses: divides el precio en pagos mensuales sin agregar intereses, si cumples las condiciones del banco."
    ],
    steps: [
      "Configura tu tarjeta con los datos de tu banco.",
      "Agrega compras nuevas o compras a meses que ya estabas pagando.",
      "Registra cada pago una sola vez."
    ],
    assistantShortcut: {
      title: "Cu\xE9ntale la compra a tu asistente",
      description: "Describe una compra de hoy o una que ya pagas a meses. Tambi\xE9n puede ayudarte a configurar tu primera tarjeta o registrar un pago. Ver\xE1s una vista previa antes de guardar.",
      note: "Nada se guarda hasta que confirmas. Interpretar el mensaje inicial usa 1 consulta; guardar o cancelar no usa otra. Necesitas una prueba activa o una suscripci\xF3n.",
      action: { label: "Contar esta compra", to: "/asistente" }
    },
    action: { label: "Configurar mi tarjeta", to: "/tarjeta?accion=configurar" }
  },
  recurring: {
    section: "recurring",
    route: "/gastos-fijos",
    eyebrow: "Movimientos fijos",
    title: "Automatiza lo que se repite",
    summary: "Programa rentas, servicios, ingresos o apartados para que se registren autom\xE1ticamente.",
    keyIdeas: [
      "Todos los d\xEDas a las 6:00 a. m., hora de Ciudad de M\xE9xico, la app registra los movimientos cuya fecha lleg\xF3.",
      "Cambiar este mes modifica s\xF3lo ese importe; editar pr\xF3ximos movimientos cambia la programaci\xF3n futura.",
      "Puedes procesar manualmente lo pendiente de hoy sin crear duplicados."
    ],
    steps: [
      "Agrega el cargo, ingreso o apartado que se repite.",
      "Elige su d\xEDa, frecuencia y monto habitual.",
      "Revisa los pendientes; la app los registrar\xE1 autom\xE1ticamente cuando llegue su fecha."
    ],
    assistantShortcut: {
      title: "Revisa tus pagos del mes",
      description: "Preg\xFAntale cu\xE1ntos pagos se repiten este mes y cu\xE1nto suman.",
      note: "Este an\xE1lisis usa una consulta. Cada movimiento fijo se programa aqu\xED.",
      action: { label: "Preguntar por mis pagos", to: "/asistente" }
    },
    action: { label: "Agregar un movimiento fijo", to: "/gastos-fijos?nuevo=1" }
  },
  loans: {
    section: "loans",
    route: "/deudas",
    eyebrow: "Deudas y pr\xE9stamos",
    title: "Sigue lo que falta por pagar",
    summary: "Lleva el saldo, la mensualidad y la fecha de tus pr\xE9stamos sin mezclarlos con la tarjeta.",
    keyIdeas: [
      "Saldo pendiente: la parte de la deuda que todav\xEDa falta pagar.",
      "Registrar una deuda no saca dinero de una cuenta; cada pago se registra cuando ocurre.",
      "El asistente puede orientarte. Las deudas y sus pagos se registran aqu\xED."
    ],
    steps: [
      "Agrega la deuda.",
      "Escribe cu\xE1nto falta y cu\xE1nto pagas normalmente.",
      "Actualiza el saldo cuando hagas un pago."
    ],
    action: { label: "Agregar una deuda", to: "/deudas?nuevo=1" }
  },
  budget: {
    section: "budget",
    route: "/presupuesto",
    eyebrow: "Presupuesto",
    title: "Pon un l\xEDmite que puedas seguir",
    summary: "Decide cu\xE1nto quieres gastar en el mes y revisa cu\xE1nto te queda dentro de ese l\xEDmite.",
    keyIdeas: [
      "Presupuesto: el l\xEDmite que eliges para organizar tus gastos; no es el saldo de tu cuenta.",
      "Disponible del presupuesto: lo que queda de ese l\xEDmite despu\xE9s de tus gastos registrados."
    ],
    steps: [
      "Revisa la sugerencia de la app.",
      "C\xE1mbiala si no representa tu realidad.",
      "Mira qu\xE9 categor\xEDas se acercan a su l\xEDmite."
    ],
    assistantShortcut: {
      title: "Pregunta cu\xE1nto te queda",
      description: "El asistente puede explicarte cu\xE1nto queda de tu presupuesto y c\xF3mo se calcula.",
      note: "Este an\xE1lisis usa una consulta.",
      action: { label: "Revisar con el asistente", to: "/asistente" }
    },
    action: { label: "Revisar mi presupuesto", to: "/presupuesto" }
  },
  goals: {
    section: "goals",
    route: "/metas",
    eyebrow: "Metas de ahorro",
    title: "Dale un prop\xF3sito a tu ahorro",
    summary: "Define para qu\xE9 quieres ahorrar, cu\xE1nto necesitas y, si quieres, para cu\xE1ndo.",
    keyIdeas: [
      "Crear una meta no mueve dinero.",
      "Una meta respaldada s\xED est\xE1 ligada a dinero guardado en una cuenta o apartado."
    ],
    steps: [
      "Ponle nombre y monto a la meta.",
      "Elige una fecha s\xF3lo si te ayuda.",
      "Vincula un apartado cuando quieras separar el dinero de verdad."
    ],
    assistantShortcut: {
      title: "Revisa tu avance",
      description: "Preg\xFAntale cu\xE1nto llevas y cu\xE1nto te falta para llegar a tu meta.",
      note: "Este an\xE1lisis usa una consulta. Las metas se crean aqu\xED.",
      action: { label: "Preguntar por mi meta", to: "/asistente" }
    },
    action: { label: "Crear una meta", to: "/metas?nuevo=1" }
  },
  assistant: {
    section: "assistant",
    route: "/asistente",
    eyebrow: "Asistente personal",
    title: "Convierte tus datos en decisiones",
    summary: "Puedes registrar con una frase, preguntar por tus n\xFAmeros o revisar una compra antes de decidir.",
    keyIdeas: [
      "Para registrar, cuenta lo que pas\xF3. El asistente prepara los datos y t\xFA confirmas.",
      "Interpretar el mensaje inicial de un movimiento o una compra usa 1 consulta.",
      "Responder un dato directo normalmente no usa otra consulta; una aclaraci\xF3n que requiera interpretar lenguaje libre s\xED puede usar otra.",
      "Guardar o cancelar una propuesta no usa otra consulta.",
      "Pedir ayuda para encontrar una funci\xF3n de la app no usa consultas.",
      "El asistente s\xF3lo usa lo que registraste y nunca decide por ti."
    ],
    steps: [
      "Elige si quieres registrar algo o hacer una pregunta.",
      "Escribe como lo contar\xEDas normalmente.",
      "Revisa el resultado antes de confirmar o decidir."
    ]
  },
  settings: {
    section: "settings",
    route: "/ajustes",
    eyebrow: "Ajustes",
    title: "Adapta los c\xE1lculos a tu realidad",
    summary: "Aqu\xED cambias tu ingreso habitual, moneda, ahorro deseado y permiso para usar el asistente.",
    keyIdeas: [
      "Tu ingreso base ayuda a hacer planes; no crea un ingreso en tus movimientos.",
      "Puedes retirar el permiso del asistente cuando quieras.",
      "La prueba se ofrece una sola vez por cuenta, despu\xE9s de verificar tu correo.",
      "Los 14 d\xEDas empiezan cuando guardas el permiso de IA por primera vez. Retirarlo no pausa ni reinicia el plazo."
    ],
    steps: [
      "Revisa tus datos.",
      "Cambia s\xF3lo lo que ya no represente tu situaci\xF3n.",
      "Guarda y vuelve a tu panorama."
    ],
    action: { label: "Revisar mis ajustes", to: "/ajustes" }
  },
  more: {
    section: "more",
    route: "/mas",
    eyebrow: "M\xE1s herramientas",
    title: "Encuentra lo que no usas todos los d\xEDas",
    summary: "Desde aqu\xED puedes abrir tarjeta, movimientos fijos, deudas, presupuesto, metas y ajustes.",
    keyIdeas: [
      "Nada se modifica al abrir una herramienta.",
      "Puedes volver a esta pantalla desde la barra inferior."
    ],
    steps: [
      "Elige lo que quieres revisar.",
      "Lee la ayuda de esa secci\xF3n si es tu primera vez.",
      "Regresa aqu\xED para cambiar de herramienta."
    ],
    action: { label: "Revisar mi tarjeta", to: "/tarjeta" }
  }
};
function sectionGuideForPath(pathname) {
  return Object.values(APP_SECTION_GUIDES).find((guide) => guide.route === pathname);
}
export {
  ACCOUNT_DELETION_CONFIRMATION,
  APP_CURRENCY,
  APP_GUIDE_VERSION,
  APP_HELP_DESTINATIONS,
  APP_SECTIONS,
  APP_SECTION_GUIDES,
  APP_TIMEZONE,
  ASSISTANT_PROPOSAL_CONTRACT_VERSION,
  AccountReconciliationReason,
  AccountReconciliationStatus,
  AccountType,
  CategoryKind,
  LoanKind,
  LoanPaymentStatus,
  PlannedMovementKind,
  PlannedMovementStatus,
  RecurringDirection,
  RecurringFrequency,
  RecurringSourceKind,
  SUPPORTED_CURRENCIES,
  TransactionType,
  addMonths,
  amountForMonth,
  availableFree,
  budgetStatus,
  businessDate,
  businessMonthBounds,
  computeCardCycle,
  diffMonths,
  hasAmountOverride,
  hasPendingInstallments,
  indexToMonth,
  installmentProgress,
  isActiveInMonth,
  isCash,
  isFinished,
  isFiniteNonNegativeAmount,
  isLoanActive,
  isPaidOff,
  isWithinCycle,
  isWithinRecurringTerm,
  limitUsageRatio,
  loanProgress,
  loanRemainingBalance,
  monthToIndex,
  monthlyAmount,
  monthlySavingsTarget,
  monthsRemaining,
  monthsUntil,
  nextBusinessMonthDate,
  projectNextStatement,
  projectedMonthlyClosing,
  recurringFrequencyMonths,
  recurringMonthsRemaining,
  recurringOccurrenceCount,
  recurringOccurrencesRemaining,
  remainingBalance,
  savingsSuggestion,
  sectionGuideForPath,
  suggestedMonthlyLimit,
  sumFiniteNonNegativeAmounts,
  termsRemaining,
  toYearMonth,
  totalActiveInMonth,
  totalMonthlyLoanPayments,
  totalMsiDebt
};
//# sourceMappingURL=index.mjs.map